import React from "react";

export function Header({ onClose }) {
  return (
    <div className="newPopupTitle">
      <div className="popup-name">No Show Appointment</div>
      <button className="popupClose" onClick={onClose}>
        <img src="/images/close.png" alt="" />
      </button>
    </div>
  );
}
